export default "__VITE_ASSET__Cp_YfHYz__"